export const PFASSTATES = ['MN', 'ME', 'CO', 'CT'];
